import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Navbar        from "./components/Navbar";
import Footer        from "./components/Footer";
import Home          from "./pages/Home";
import Products      from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Cart          from "./pages/Cart";
import Admin         from "./pages/Admin";
import Login         from "./pages/Login";
import Checkout      from "./pages/Checkout";
import AdminOrders   from "./pages/AdminOrders";
import AdminDashboard from "./pages/AdminDashboard";
import TrackOrder    from "./pages/TrackOrder";
import NewArrivals   from "./pages/NewArrivals";
import Contact       from "./pages/Contact";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed  from "./pages/PaymentFailed";

import { CurrencyProvider } from "./context/CurrencyContext";
import API_URL from "./config";

// ── Track unique visitors (fires once per session) ──────────────────────────
function VisitorTracker() {
  useEffect(() => {
    if (!sessionStorage.getItem("visited")) {
      fetch(`${API_URL}/api/visitors/track`, { method: "POST" }).catch(() => {});
      sessionStorage.setItem("visited", "1");
    }
  }, []);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <CurrencyProvider>
        <Router>
          <VisitorTracker />
          <Navbar />
          <Routes>
            <Route path="/"                element={<Home />} />
            <Route path="/products"        element={<Products />} />
            <Route path="/product/:id"     element={<ProductDetails />} />
            <Route path="/cart"            element={<Cart />} />
            <Route path="/admin"           element={<Admin />} />
            <Route path="/login"           element={<Login />} />
            <Route path="/checkout"        element={<Checkout />} />
            <Route path="/admin/orders"    element={<AdminOrders />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/track"           element={<TrackOrder />} />
            <Route path="/new-arrivals"    element={<NewArrivals />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-failed"  element={<PaymentFailed />} />
            <Route path="/contact"         element={<Contact />} />
          </Routes>
          <Footer />
        </Router>
      </CurrencyProvider>
    </HelmetProvider>
  );
}

export default App;